import React from 'react';
import { Droplet, Clock, Shield, Sparkles, Phone, Mail } from 'lucide-react';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';

export const RecruitmentSection = () => {
  return (
    <section id="recrutement" className="py-24 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-[#0205B3] to-[#0205B3] text-white relative overflow-hidden" data-testid="recruitment-section">
      {/* Decorative elements */}
      <div className="absolute top-10 right-10 text-white/10">
        <Droplet className="h-32 w-32" fill="currentColor" />
      </div>
      <div className="absolute bottom-10 left-10 text-white/10">
        <Droplet className="h-24 w-24" fill="currentColor" />
      </div>

      <div className="max-w-4xl mx-auto relative z-10">
        <div className="text-center mb-12">
          <div className="inline-flex items-center space-x-2 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full text-sm font-medium mb-4">
            <Sparkles className="h-4 w-4" />
            <span>Nous recrutons</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold mb-4">
            Rejoignez Notre Équipe !
          </h2>
          <p className="text-xl text-blue-50">
            Nous recherchons un(e) employé(e) passionné(e) et expérimenté(e)
          </p>
        </div>

        <Card className="bg-white text-gray-900 border-0 shadow-2xl">
          <CardContent className="p-8 lg:p-12">
            <div className="space-y-8">
              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
                  <div className="bg-blue-100 rounded-full p-2 mr-3">
                    <Shield className="h-6 w-6 text-[#0205B3]" />
                  </div>
                  Poste à Pourvoir
                </h3>

                <div className="grid md:grid-cols-2 gap-6 mb-8">
                  <div className="bg-blue-50 rounded-xl p-6">
                    <div className="flex items-start space-x-3">
                      <Clock className="h-6 w-6 text-[#0205B3] mt-1" />
                      <div>
                        <div className="font-semibold text-gray-900 mb-1">Type de contrat</div>
                        <div className="text-gray-700">Temps plein (35h/semaine)</div>
                      </div>
                    </div>
                  </div>

                  <div className="bg-blue-50 rounded-xl p-6">
                    <div className="flex items-start space-x-3">
                      <Sparkles className="h-6 w-6 text-[#0205B3] mt-1" />
                      <div>
                        <div className="font-semibold text-gray-900 mb-1">Salaire</div>
                        <div className="text-gray-700">Rémunération intéressante</div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-amber-50 border-l-4 border-amber-500 p-6 rounded-r-xl mb-8">
                  <div className="flex items-start space-x-3">
                    <Shield className="h-6 w-6 text-amber-600 mt-1 flex-shrink-0" />
                    <div>
                      <div className="font-bold text-amber-900 mb-2">
                        ⚠️ Critère TRÈS IMPORTANT : Expérience OBLIGATOIRE
                      </div>
                      <div className="text-amber-800">
                        Vous devez avoir déjà travaillé dans un pressing.
                        L'expérience professionnelle dans le secteur est indispensable.
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <h4 className="font-bold text-lg text-gray-900 mb-4">Profil recherché :</h4>
                <ul className="space-y-3">
                  {[
                    "Expérience confirmée dans un pressing (obligatoire)",
                    "Maîtrise des techniques de nettoyage à sec et repassage",
                    "Sens du service client et accueil chaleureux",
                    "Autonomie, rigueur et sens du détail",
                    "Disponibilité immédiate appréciée"
                  ].map((criterion) => (
                    <li key={criterion} className="flex items-start">
                      <div className="bg-blue-100 rounded-full p-1 mr-3 mt-1">
                        <div className="h-2 w-2 rounded-full bg-[#0205B3]"></div>
                      </div>
                      <span className="text-gray-700">{criterion}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="bg-gradient-to-r from-blue-50 to-blue-50 rounded-xl p-6">
                <div className="flex items-center justify-between flex-wrap gap-4">
                  <div>
                    <div className="font-bold text-gray-900 text-lg mb-1">
                      Poste disponible immédiatement
                    </div>
                    <div className="text-gray-600">
                      Contactez-nous pour en savoir plus
                    </div>
                  </div>
                  <div className="flex flex-col sm:flex-row gap-3">
                    <Button
                      className="bg-[#0205B3] hover:bg-[#0205B3] text-white px-6 py-6"
                      onClick={() => { window.location.href = 'tel:0783811313'; }}
                      data-testid="recruitment-call-btn"
                    >
                      <Phone className="mr-2 h-5 w-5" />
                      07 83 81 13 13
                    </Button>
                    <Button
                      variant="outline"
                      className="border-2 border-[#0205B3] text-[#0205B3] hover:bg-blue-50 px-6 py-6"
                      onClick={() => { window.location.href = 'mailto:pressingaquabluenet@gmail.com'; }}
                      data-testid="recruitment-email-btn"
                    >
                      <Mail className="mr-2 h-5 w-5" />
                      Envoyer un email
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </section>
  );
};
